module.exports = __webpack_public_path__ + "img/login_bc1.e821643a.png";